<template>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" :width="width" :height="height"
       viewBox="0 0 188 188">
    <defs>
      <linearGradient id="linear-gradient" x1="0.852" y1="0.143" x2="0.104" y2="0.832"
                      gradientUnits="objectBoundingBox">
        <stop offset="0" stop-color="#e21851"/>
        <stop offset="1" stop-color="#0f4cf3"/>
      </linearGradient>
    </defs>
    <g id="Group_2434" data-name="Group 2434" transform="translate(-121 -3013)">
      <circle id="Ellipse_101" data-name="Ellipse 101" cx="94" cy="94" r="94" transform="translate(121 3013)"
              fill="url(#linear-gradient)"/>
      <g id="messenger" transform="translate(170.14 3057.14)">
        <path id="Exclusion_16" data-name="Exclusion 16"
              d="M-164.334-2963.42a2.82,2.82,0,0,1-1.984-.823,2.8,2.8,0,0,1-.622-3.022l7.462-18.374a47.634,47.634,0,0,1-7.663-25.642,47.173,47.173,0,0,1,3.781-18.569,48.029,48.029,0,0,1,10.291-15.22,48.032,48.032,0,0,1,15.219-10.291,47.172,47.172,0,0,1,18.568-3.781,47.169,47.169,0,0,1,18.568,3.781,48.024,48.024,0,0,1,15.22,10.291A48.029,48.029,0,0,1-75.2-3029.849a47.173,47.173,0,0,1,3.781,18.568,47.171,47.171,0,0,1-3.781,18.568,48.029,48.029,0,0,1-10.291,15.219,48.028,48.028,0,0,1-15.22,10.29,47.174,47.174,0,0,1-18.568,3.781,47.627,47.627,0,0,1-25.641-7.663l-18.373,7.464A2.8,2.8,0,0,1-164.334-2963.42Zm38.738-41.8v0h0l9.941,9.939a2.823,2.823,0,0,0,1.983.822h.082a2.823,2.823,0,0,0,2.012-.942l22.434-25.239a2.794,2.794,0,0,0,.217-3.448,2.792,2.792,0,0,0-2.308-1.222,2.791,2.791,0,0,0-.99.181l-20.741,7.781-9.941-9.941a3.121,3.121,0,0,0-2.065-.822,2.819,2.819,0,0,0-2.013.942l-22.434,25.239a2.794,2.794,0,0,0-.216,3.448,2.8,2.8,0,0,0,2.311,1.216,2.857,2.857,0,0,0,.985-.176Z"
              transform="translate(167.14 3059.14)" fill="#f8f8f8"/>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "IFacebookMessenger",
  props: {
    width: {
      type: String,
      default: '1.5em'
    },
    height: {
      type: String,
      default: '1.5em'
    }
  }
}
</script>

<style scoped>

</style>
